type LogLevel = 'info' | 'warn' | 'error' | 'debug';

interface Logger {
	log: (level: LogLevel, message: string, ...optionalParams: unknown[]) => void;
	info: (message: string, ...optionalParams: unknown[]) => void;
	warn: (message: string, ...optionalParams: unknown[]) => void;
	error: (message: string, ...optionalParams: unknown[]) => void;
	debug: (message: string, ...optionalParams: unknown[]) => void;
}

const logger: Logger = {
	log(level, message, ...optionalParams) {
		switch (level) {
			case 'info': {
				console.info(`[INFO]: ${message}`, ...optionalParams);
				break;
			}
			case 'warn': {
				console.warn(`[WARN]: ${message}`, ...optionalParams);
				break;
			}
			case 'error': {
				console.error(`[ERROR]: ${message}`, ...optionalParams);
				break;
			}
			case 'debug': {
				console.debug(`[DEBUG]: ${message}`, ...optionalParams);
				break;
			}
			default: {
				console.log(`[LOG]: ${message}`, ...optionalParams);
			}
		}
	},
	info(message, ...optionalParams) {
		logger.log('info', message, ...optionalParams);
	},
	warn(message, ...optionalParams) {
		logger.log('warn', message, ...optionalParams);
	},
	error(message, ...optionalParams) {
		logger.log('error', message, ...optionalParams);
	},
	debug(message, ...optionalParams) {
		logger.log('debug', message, ...optionalParams);
	}
};

export default logger;
